import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import ModalDlg from 'components/Basic/ModalDlg';
import { ArrowForward } from '@material-ui/icons';
import { GoogleMap } from '@react-google-maps/api';
import Marker from 'components/Basic/Marker';
import { getLocations } from 'utilities/common';

const MAP_CONTAINER_STYLE = { width: '100%', height: '100%' };

function AmbassadorMapModal({ data, isOpenModal, onCloseModal }) {
  const center = {
    lat: data?.locationLat || getLocations().lat,
    lng: data?.locationLong || getLocations().lng,
  };

  return (
    <ModalDlg className="ambassador_map_modal" visible={isOpenModal} width={450} handleCancel={onCloseModal} isCenter>
      <div className="modal_content">
        <div className="ambassador_map_layout">
          <GoogleMap mapContainerStyle={MAP_CONTAINER_STYLE} center={center} zoom={10}>
            {data && data.locationLat && (
              <Marker
                lat={center.lat}
                lng={center.lng}
                description={`${data.firstName || ''} ${data.lastName || ''}`}
              />
            )}
          </GoogleMap>
        </div>
      </div>
      <div className="modal_footer">
        <Button onClick={onCloseModal}>
          <FormattedMessage id="Close" />
          <ArrowForward />
        </Button>
      </div>
    </ModalDlg>
  );
}

AmbassadorMapModal.defaultProps = {
  isOpenModal: false,
  data: {},
};

export default AmbassadorMapModal;
